export const GET_ACTION_INFO = 'GET_ACTION_INFO'
export const GET_IMPORT_IFRAME = 'GET_IMPORT_IFRAME'
export const GET_EXPORT_IFRAME = 'GET_EXPORT_IFRAME'
export const RESET_DIALOG = 'RESET_DIALOG'
